import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";

export const certificationsProjectsRoutes: RouteRecordRaw = {
  path: "projects",
  name: "Certifications Projects",
  redirect: { name: "Certifications Projects List" },
  meta: { permissions: [PermissionEnum.PROJECTS_PROJECT] },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "list",
      name: "Certifications Projects List",
      component: () => import("@/views/auth/projects/projects/ProjectList.vue"),
    },
    {
      path: "edit/:id",
      name: "Certifications Edit Project",
      component: () => import("@/views/auth/projects/projects/EditProject.vue"),
      props: true,
    },
    {
      path: "new",
      name: "Certifications New Project",
      component: () => import("@/views/auth/projects/projects/NewProject.vue"),
    },
    {
      path: "copy/:id",
      name: "Certifications Copy Project",
      component: () => import("@/views/auth/projects/projects/CopyProject.vue"),
      props: true,
    },
    {
      path: "detail/:id",
      name: "Certifications Project Detail",
      redirect: { name: "Certifications Project Resources" },
      component: () => import("@/views/auth/projects/projects/ProjectDetail.vue"),
      props: true,
      children: [
        {
          path: "contacts",
          name: "Certifications Project Contacts",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectContactsTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "expenses",
          name: "Certifications Project Expenses",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectExpensesTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "on-calls",
          name: "Certifications Project On Calls",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectOnCallsTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectOnCallsSidebar.vue"),
          },
          props: true,
        },
        {
          path: "worksheets",
          name: "Certifications Project Worksheets",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectWorksheetsTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "economic",
          name: "Certifications Project Economic",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectEconomicTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "documentation",
          name: "Certifications Project Documentation",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectDocumentationTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "worksheet-documentation",
          name: "Certifications Project Worksheet Documentation",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectWorksheetDocumentationTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "task-files",
          name: "Certifications Project Task Files",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectTaskFilesTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "technical-office",
          name: "Certifications Project Technical Office",
          meta: { permissions: [PermissionEnum.PROJECT_TECHNICAL_REPORT] },
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectTechnicalOfficeTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "configuration",
          name: "Certifications Project Configuration",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectConfigurationTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
        {
          path: "resources",
          name: "Certifications Project Resources",
          components: {
            default: () => import("@/modules/projects/components/tabs/ProjectResourcesTab.vue"),
            sidebar: () => import("@/modules/projects/components/sidebars/ProjectRightSidebar.vue"),
          },
          props: true,
        },
      ],
    },
  ],
};
